module.exports = __webpack_public_path__ + "img/Officebuilding.443e5090.svg";